import { render, staticRenderFns } from "./Excel.vue?vue&type=template&id=ca56f8d2"
import script from "./Excel.vue?vue&type=script&lang=js"
export * from "./Excel.vue?vue&type=script&lang=js"
import style0 from "./Excel.vue?vue&type=style&index=0&id=ca56f8d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports